'use strict';

import { threeJsVariables } from '../../../settings';

export class QualityCore {
	constructor (cfg) {
		this.cfg = cfg;
	}
	
	pixelRatio() {
		if (this.cfg.hasOwnProperty('pixelRatio')) {
			return this.cfg.pixelRatio;
		}
		
		return Math.min(window.devicePixelRatio, 2);
	}
	
	optimizationTasks() {
		if (this.cfg.hasOwnProperty('optimizationTasks')) {
			return this.cfg.optimizationTasks;
		}
		
		return true;
	}
	
	cloudflareParams(defValue) {
		if (this.cfg.hasOwnProperty('cloudflareParams')) {
			return this.cfg.cloudflareParams;
		}
		
		return defValue;
	}
	
	shadowNormalBias(defValue) {
		if (this.cfg.hasOwnProperty('shadowNormalBias')) {
			return this.cfg.shadowNormalBias
		}
		
		return defValue;
	}
	
	castShadowForAnimatedObjects() {
		if (this.cfg.hasOwnProperty('castShadowForAnimatedObjects')) {
			return this.cfg.castShadowForAnimatedObjects;
		}
		
		return false;
	}
	
	shadowMapSize(defValue) {
		if (this.cfg.hasOwnProperty('shadowMapSize')) {
			return this.cfg.shadowMapSize;
		}
		
		return defValue;
	}
	
	shadowCameraSize(defValue) {
		if (this.cfg.hasOwnProperty('shadowCameraSize')) {
			return this.cfg.shadowCameraSize;
		}
		
		return defValue;
	}
	
	autoUpdateShadowMap() {
		if (this.cfg.hasOwnProperty('autoUpdateShadowMap')){
			return this.cfg.autoUpdateShadowMap;
		}
		
		return false;
	}
	
	composerSamples(defValue) {
		if (this.cfg.hasOwnProperty('composerSamples')) {
			return this.cfg.composerSamples;
		}
		
		return defValue;
	}
	
	tilesErrorTarget(defValue) {
		if (this.cfg.hasOwnProperty('tilesErrorTarget')) {
			return this.cfg.tilesErrorTarget;
		}
		
		return defValue;
	}
	
	tilesMaxDepth(defValue) {
		if (this.cfg.hasOwnProperty('tilesMaxDepth')) {
			return this.cfg.tilesMaxDepth;
		}
		
		return defValue;
	}
	
	lodMaxDistance() {
		if (this.cfg.hasOwnProperty('lodMaxDistance')) {
			return this.cfg.lodMaxDistance;
		}
		
		return threeJsVariables.perspectiveCamera.far;
	}
	
	lodLevel() {
		if (this.cfg.hasOwnProperty('lodLevel')) {
			return this.cfg.lodLevel;
		}
		
		return -1;
	}
	
	lodDistanceCoefficient() {
		if (this.cfg.hasOwnProperty('lodDistanceCoefficient')) {
			return this.cfg.lodDistanceCoefficient;
		}
		
		return 1;
	}
}
